import React, { useEffect, useState } from 'react';
import { Grid, Typography, Paper, IconButton, Box, Select } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import {
  format, startOfMonth, endOfMonth, startOfWeek, endOfWeek,
  addDays, isSameMonth, isSameDay, addMonths, isSameDay as isSameCalendarDay
} from 'date-fns';
import SyncIcon from '@mui/icons-material/Sync';
import MenuItem from '@mui/material/MenuItem';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { LinkedinPostPreview } from './LinkedinPostPreview';

const Calendar = ({ posts, sync, schedulable, setScheduledTime, deletePost }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const monthStart = startOfMonth(currentMonth);
  const monthEnd = endOfMonth(monthStart);
  const calendarStart = startOfWeek(monthStart, { weekStartsOn: 0 });
  const calendarEnd = endOfWeek(monthEnd, { weekStartsOn: 0 });

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const [selectedPost, setSelectedPost] = useState(null);
  const [showDeletionConfirmation, setShowDeletionConfirmation] = useState(false);

  const days = [];
  let day = calendarStart;
  while (day <= calendarEnd) {
    days.push(day);
    day = addDays(day, 1);
  }

  const nextMonth = () => setCurrentMonth(prev => addMonths(prev, 1));
  const prevMonth = () => setCurrentMonth(prev => addMonths(prev, -1));

  const getPostsForDay = date =>
    posts
      .filter(p => isSameCalendarDay(new Date(p.scheduledAt), date))
      .sort((a, b) => a.scheduledAt - b.scheduledAt);

  useEffect(() => {
    if (selectedDate && selectedTime) {
      // convert 1am, 12pm etc to 01:00, 12:00 etc
      let [hours, minutes] = selectedTime.split(':');
      // handle pm
      if (selectedTime.includes('pm')) {
        hours = parseInt(hours) + 12;
      }
      if (hours.length == 1) {
        hours = '0' + hours;
      }
      if (minutes?.length == 1) {
        minutes = '0' + minutes;
      } else {
        minutes = '00';
      }
      
      let tim = new Date(format(selectedDate, 'yyyy-MM-dd') + ' ' + hours + ':' + minutes).getTime() / 1000;
      tim *= 1000;
      console.log("selectedDate", selectedDate, selectedTime, tim);
      setScheduledTime(tim)
    }
  }, [selectedDate, selectedTime]);

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <IconButton onClick={prevMonth}><ArrowBack /></IconButton>
        <div style={{
            textAlign: "center"
        }}>
        <Typography variant={schedulable ? "body" : "h5"}>
          {format(monthStart, 'MMMM yyyy')}
          <IconButton onClick={sync}><SyncIcon /></IconButton>
        </Typography>
        </div>
        <IconButton onClick={nextMonth}><ArrowForward /></IconButton>
      </Box>

      <Grid container spacing={1}>
        {['S','M','Tu','W','Th','F','S'].map(d => (
          <Grid item xs={1.714} key={d}>
            <Typography align="center" variant="subtitle2" style={{
                color: "#ccc"
            }}>{d}</Typography>
          </Grid>
        ))}

        {days.map((d, i) => {
          const dayPosts = getPostsForDay(d);
          return (
            <Grid item xs={1.714} key={i}>
              <Paper
                elevation={0}
                sx={{
                  height: 100,
                  bgcolor: "white",
                  border: border(d),
                  color: color(d),
                  p: 1,
                  overflow: 'auto',
                  '&:hover': {
                    border: schedulable ? '1px solid #333' : border(d),
                    cursor: schedulable ? 'pointer' : 'default',
                  },
                }}
                onClick={() => {
                  if (!schedulable) return;

                  setSelectedTime(selectedTime || "11:30am");
                  setSelectedDate(format(d, 'yyyy-MM-dd'));

                }}
              >
                <Typography style={{
                  fontSize: "0.8rem",
                  color: "#888",
                }}>{format(d, 'd')}</Typography>
                  {selectedDate == format(d, 'yyyy-MM-dd') && selectedTime && (
                    <Typography variant="caption" display="block" style={{
                      color: "purple",
                    }}>
                      <Select style={{
                        fontSize: "0.8rem",
                        color: "purple"
                      }} 
                      IconComponent={() => null}
                      variant="standard"
                      disableUnderline
                      inputProps={{ sx: { padding: 0 } }}
                      sx={{
                        fontSize: "0.8rem",
                        color: "purple",
                        padding: 0,
                        border: "none",
                        '&::before': { borderBottom: 'none' },
                        '&::after': { borderBottom: 'none' },
                      }}
                      value={selectedTime} onChange={(e) => {
                        setSelectedTime(e.target.value)
                      }} onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}>
                        {["12am", "12:30am", "1am", "1:30am", "2am", "2:30am", "3am", "3:30am", "4am", "4:30am", "5am", "5:30am", "6am", "6:30am", "7am", "7:30am", "8am", "8:30am", "9am", "9:30am", "10am", "10:30am", "11am", "11:30am", "12pm", "12:30pm", "1pm", "1:30pm", "2pm", "2:30pm", "3pm", "3:30pm", "4pm", "4:30pm", "5pm", "5:30pm", "6pm", "6:30pm", "7pm", "7:30pm", "8pm", "8:30pm", "9pm", "9:30pm", "10pm", "10:30pm", "11pm", "11:30pm"].map((t, j) => (
                          <MenuItem value={t} style={{
                            backgroundColor: ["7am", "7:30am", "8am", "8:30am", "9am", "9:30am", "10am", "10:30am", "11am", "11:30am", "12pm", "12:30pm", "1pm", "1:30pm", "2pm", "2:30pm", "3pm", "3:30pm", "4pm", "4:30pm"].indexOf(t) >= 0 ? 'rgb(235 255 235)': 'white'
                          }}>{t}</MenuItem>
                        ))}
                      </Select>
                    </Typography>
                  )}

                    {dayPosts.map((p, idx) => (
                    <Typography key={idx} variant="caption" display="block" onClick={() => {
                      if (schedulable) return;
                      setSelectedPost(p);
                    }}>
                        {format(new Date(p.scheduledAt), 'h:mm a')} — {p.text?.slice(0, 20)}
                    </Typography>
                    ))}
              </Paper>
            </Grid>
          );
        })}
      </Grid>
      <Dialog open={!!selectedPost} onClose={() => {
        setSelectedPost(null);
        setShowDeletionConfirmation(false);
      }}>
        <DialogTitle>Delete Post</DialogTitle>
        <DialogContent>
          {selectedPost && <LinkedinPostPreview text={selectedPost.text} setText={() => {}} />}

          {!showDeletionConfirmation && (
            <div style={{
              marginTop: 20,
              fontSize: "0.9rem",
            }}>
              <a href='#' onClick={() => {
                setShowDeletionConfirmation(true);
              }}>Delete Post</a>
            </div>
          )}
          {showDeletionConfirmation && (
            <div style={{
              marginTop: 20,
              fontSize: "0.9rem",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}>
              <div>Are you sure you want to delete this post? This action cannot be undone.</div>
              <div style={{
                display: "flex",
                flexDirection: "row",
                gap: 40,
              }}>
                <a href='#' style={{
                  color: "red",
                }} onClick={() => {
                  setShowDeletionConfirmation(false);
                  deletePost(selectedPost);
                }}>Yes, Delete Post</a>
                <a href='#' onClick={() => {
                  setShowDeletionConfirmation(false);
                  setSelectedPost(null);
                  
                }}>Cancel</a>
                
              </div>
            </div>
          )}
        </DialogContent>
        
      </Dialog>
    </Box>
  );
};

const todayDate = new Date();

function border(d) {
    if (isSameDay(d, todayDate)) {
        return '1px solid #333';
    }
    if (isSameMonth(d, todayDate)) {
        return '1px solid #ddd';
    }
    return '1px solid #eee';
}
function color(d) {
    if (isSameMonth(d, todayDate)) {
        return '#333';
    }
    return '#666';
}

export default Calendar;
